<template>
  <Modal id="modal-review" v-slot="{ close, data }">
    <ModalShell size="md" title="Update Review" :close="close">
      <div class="p-4 lg:p-8">
        <StoreProductReview :id="data" @refresh="refresh()" />
      </div>
    </ModalShell>
  </Modal>
</template>

<script>
export default {
  emits: ["refresh"],
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
